// Shared, timezone-safe formatter for bare "YYYY-MM-DD" date strings
// (order/quote from_date, to_date, invoice dates, etc.).
//
// A date-only string like "2026-09-21" parses as UTC midnight per the
// ISO 8601 spec when handed to `new Date()` directly — in any timezone
// behind UTC, .toLocaleDateString() then renders the *previous* day.
// Appending a time component makes the browser parse it as local time
// instead, which is what actually avoids the rollback; the specific time
// chosen doesn't matter once a time component is present at all.
//
// The backend has its own copy of this same function (backend/lib/fmtDate.js)
// since there's no shared package between the two repos — keep both in
// sync by hand.
export function fmtDate(d, opts = { month: 'short', day: 'numeric', year: 'numeric' }) {
  if (!d) return '—';
  return new Date(d + 'T00:00:00').toLocaleDateString('en-US', opts);
}
